import { useEffect, useRef } from 'react';

/** An event bus, providing a way to fire events in one place and listen to them elsewhere. */
export class EventBus<T = void> {
  private listeners = new Set<Consumer<T>>();

  public listen = (handler: Consumer<T>) => {
    this.listeners.add(handler);
    return () => this.listeners.delete(handler);
  };

  public send = (value: T) => {
    this.listeners.forEach(it => it(value));
  };
}

type Consumer<T> = (value: T) => void;

/** Listens for events on a given bus and runs the given callback. */
export const useEventBus = <T>(bus: EventBus<T> | undefined, handler: Consumer<T>) => {
  const ref = useRef(handler);
  ref.current = handler;

  useEffect(() => {
    bus?.listen(value => ref.current(value));
  }, [bus]);
};
